<script lang="ts">
  import {
    DistributorSummary,
    Notice,
    ProductSummary,
    StockInfo,
    StockLevels,
  } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";
  import CartWidgetNotice from "@retailer/svelte/CartWidget/v2/CartWidgetNotice.svelte";
  import NoRecentUpdateTooltip from "@retailer/svelte/UnifiedStock/NoRecentUpdateTooltip.svelte";
  import CartWidgetLearnMoreTooltip from "@retailer/svelte/CartWidget/v2/CartWidgetLearnMoreTooltip.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  export let distributorSummary: DistributorSummary;
  export let productSummary: ProductSummary;
  export let stockInfo: StockInfo;
  export let availableToBuy: boolean;
  export let tooltipPosition: string = "fizz-tooltip-center";
  export let tooltipMaxWidth: string = "300px";

  const buildNotice = (stockInfo: StockInfo): Notice => {
    switch (stockInfo.level) {
      case StockLevels.inStock:
        return { level: "success", message: stockInfo.level };
      case StockLevels.lowStock:
        return { level: "warning", message: stockInfo.level };
      case StockLevels.outOfStock:
        return { level: "error", message: stockInfo.level };
      case StockLevels.notSoldAtThisLocation:
        return { level: "info", message: stockInfo.level };
      case StockLevels.noRecentUpdate:
        return { level: "info", message: stockInfo.level };
      case StockLevels.allocated:
        return { level: "info", message: stockInfo.level };
      case StockLevels.temporarilyUnavailable:
        return { level: "info", message: stockInfo.level };
    }
  };

  const fulfillmentMethodsStagedRolloutEnabled = stagedRolloutCheck(
    "marketplace__fulfillment_methods",
  );
  const canUseWineCellar =
    distributorSummary?.uses_wine_cellar && fulfillmentMethodsStagedRolloutEnabled;

  $: notice = buildNotice(stockInfo);
  $: iconOverride = stockInfo.level === StockLevels.notSoldAtThisLocation ? "Info" : null;
</script>

{#if canUseWineCellar && stockInfo.level === StockLevels.noRecentUpdate && (stockInfo.reason === "SKU_NOT_FOUND" || stockInfo.reason === "STALE_DATA")}
  <NoRecentUpdateTooltip distributor={distributorSummary} product={productSummary} />
{:else if stockInfo.level === StockLevels.temporarilyUnavailable}
  <div class="fizz-text-italic fizz-text-small">
    {stockInfo.level}
  </div>
{:else if stockInfo.level}
  <CartWidgetNotice {notice} {iconOverride}>
    <CartWidgetLearnMoreTooltip
      distributor={distributorSummary}
      productId={productSummary.id}
      {notice}
      {availableToBuy}
      {tooltipPosition}
      {tooltipMaxWidth}
    />
  </CartWidgetNotice>
{/if}
